module.exports = __webpack_public_path__ + "c39cbab3856ef3be61c1b417e4e3c125.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/group-insights.png
// module id = 1637
// module chunks = 0